/* eslint-disable global-require */
export const translationResources = {
  'en-US': {
    adminDashboard: require('@percent/admin-dashboard/i18n/data/en/en.json')
  },
  'en-GB': {
    adminDashboard: require('@percent/admin-dashboard/i18n/data/en/en.json')
  }
}
